export const KPI_METRICS = [
  {
    id: "revenueGrowth",
    label: "Revenue Growth",
    category: "Revenue",
    unit: "%",
    formulaKeys: ["currentQuarterRevenue", "priorQuarterRevenue"], // you’ll fill these in manualData
    projection: true,
  },
  {
    id: "grossProfitMargin",
    label: "Gross Profit Margin",
    category: "Profitability",
    unit: "%",
    formulaKeys: ["revenue", "costOfGoodsSold"],
    projection: true,
  },
  {
    id: "ebitdaMargin",
    label: "EBITDA Margin",
    category: "Profitability",
    unit: "%",
    formulaKeys: ["ebitda", "revenue"],
    projection: true,
  },
  {
    id: "cagr",
    label: "CAGR",
    category: "Growth",
    unit: "%",
    formulaKeys: ["endingBalance", "beginningBalance", "numberOfYears"],
    projection: true,
  },

  // —————— Operational ——————
  {
    id: "operatingCashFlow",
    label: "Operating Cash Flow",
    category: "Cash Flow",
    unit: "$",
    formulaKeys: [
      "operatingIncome",
      "depreciation",
      "taxes",
      "changeInWorkingCapital",
    ],
    projection: true,
  },
  {
    id: "cashConversionCycle",
    label: "Cash Conversion Cycle",
    category: "Operational",
    unit: "days",
    formulaKeys: [
      "daysInventoryOutstanding",
      "daysSalesOutstanding",
      "daysPayablesOutstanding",
    ],
    projection: false,
  },
  {
    id: "arTurnover",
    label: "AR Turnover",
    category: "Operational",
    unit: "x",
    formulaKeys: ["netCreditSales", "avgAccountsReceivable"],
    projection: false,
  },
  {
    id: "apTurnover",
    label: "AP Turnover",
    category: "Operational",
    unit: "x",
    formulaKeys: ["totalPurchases", "avgAccountsPayable"],
    projection: false,
  },

  // —————— Efficiency & Liquidity ——————
  {
    id: "returnOnAssets",
    label: "Return on Assets",
    category: "Efficiency",
    unit: "%",
    formulaKeys: ["netIncome", "avgTotalAssets"],
    projection: true,
  },
  {
    id: "returnOnEquity",
    label: "Return on Equity",
    category: "Efficiency",
    unit: "%",
    formulaKeys: ["netIncome", "avgShareholderEquity"],
    projection: true,
  },
  {
    id: "cashRunway",
    label: "Cash Runway",
    category: "Liquidity",
    unit: "months",
    formulaKeys: ["cashBalance", "monthlyBurnRate"],
    projection: true,
  },
  {
    id: "quickRatio",
    label: "Quick Ratio",
    category: "Liquidity",
    unit: "x",
    formulaKeys: [
      "cash",
      "marketableSecurities",
      "accountsReceivable",
      "currentLiabilities",
    ],
    projection: false,
  },
  {
    id: "debtToEquity",
    label: "Debt-to-Equity Ratio",
    category: "Liquidity",
    unit: "x",
    formulaKeys: ["totalLiabilities", "shareholdersEquity"],
    projection: false,
  },
  // —————— Assets & Liabilities ——————
  {
    id: "workingCapital",
    label: "Working Capital",
    category: "Liability",
    unit: "$1",
    formulaKeys: ["currentAssets", "currentLiabilities"],
    projection: false,
  },
  {
    id: "accountsPayable",
    label: "Accounts Payable",
    category: "Liability",
    unit: "$1",
    formulaKeys: ["accountsPayable"],
    projection: false,
  },
  {
    id: "wagesPayable",
    label: "Wages Payable",
    category: "Liability",
    unit: "$1",
    formulaKeys: ["wagesPayable"],
    projection: false,
  },
  {
    id: "travelExpenses",
    label: "Travel Expenses",
    category: "Liability",
    unit: "$1",
    formulaKeys: ["travelExpenses"],
    projection: false,
  },
  {
    id: "legalFees",
    label: "Lawyers Fees",
    category: "Liability",
    unit: "$1",
    formulaKeys: ["legalFees"],
    projection: false,
  },

  // —————— Revenue & Fees ——————
  {
    id: "campaignRevenueShare",
    label: "Campaign Fee (1¢ per $1)",
    category: "Revenue",
    unit: "$1",
    formulaKeys: ["campaignGrossRevenue"],
    projection: true,
  },
  {
    id: "ccFinanceCharges",
    label: "Credit Card Finance Charges",
    category: "Cost",
    unit: "$1",
    formulaKeys: ["ccTransactionsTotal", "ccFeeRate"],
    projection: true,
  },

  // —————— Equity Liabilities ——————
  {
    id: "outstandingShares",
    label: "Outstanding Shares",
    category: "Equity",
    unit: "shares",
    formulaKeys: ["totalSharesIssued"],
    projection: false,
  },
  {
    id: "lifetimeValue",
    label: "Lifetime Value (LTV)",
    category: "Projection",
    unit: "$1",
    formulaKeys: ["avgRevenuePerUser", "churnRate", "grossMargin"],
    projection: true,
  },

  // —————— Server & Ops Cost ——————
  {
    id: "serverCost",
    label: "Monthly Server Cost",
    category: "Cost",
    unit: "$1/mo",
    formulaKeys: ["instanceHourlyRate", "hoursPerMonth", "avgConcurrentUsers"],
    projection: true,
  },
  {
    id: "ambassadorCost",
    label: "Brand Ambassador Cost",
    category: "Cost",
    unit: "$1",
    formulaKeys: ["signups", "baseRate", "bonusThreshold", "bonusRate"],
    projection: true,
  },
  {
    id: "cpcCharge",
    label: "Charge per Click",
    category: "Revenue",
    unit: "$1/click",
    formulaKeys: ["cpcRate", "clicks"],
    projection: true,
  },
  {
    id: "cpiCharge",
    label: "Charge per Impression",
    category: "Revenue",
    unit: "$1/impr",
    formulaKeys: ["cpiRate", "impressions"],
    projection: true,
  },
];
